import { useEffect, useRef, useState } from "react";
import { Center, Container } from "../../../components/Form"
import { useDispatch } from "react-redux";
import authService from "../../../service/auth";
import { addExecutiveMsg } from "../../../store/userSlice";
import { toastError } from "../../../BTUI/BtToast";
import { showDatetime } from "../../../utils/formatter";
import { IconAdd, IconMail, IconMessage, IconSendMessage } from "../../../BTUI/Icons";
import PanelLayout from "../../panelComponents/PanelLayout/PanelLayout";
import { useParams } from "react-router-dom";
import './chat-window.css'


const ChatWindowComponent = () => {
    const params = useParams()

    return<PanelLayout>
        <Container>
            <Center><h1>Chat</h1></Center>
            <br/>
            <br/>
            <ChatWindow 
                user_id={params?.id}
            />
        </Container>
    </PanelLayout>
    
}


export default ChatWindowComponent


const ChatWindow = ({ user_id }) => {
    const initialState = {
        message:"",
        category:"",
        notify_client:false
    };
    const [newMessage, setNewMessage] = useState("")
    const [messageList, setMessageList] = useState([])
    const [templateList, setTemplateList] = useState([]);
    const [category, setCategory] = useState('');
    const [payload,setPayload]= useState(initialState)
    const dispatch = useDispatch()
    const ref = useRef(null);

    useEffect(() => {
        authService.templatesList()
            .then((res) => {
                console.log("templates ", res)
                setTemplateList(res?.data?.response?.tempList)
            })
            .catch((err) => {
                console.log("templates ", err)
            })
    }, [])


    useEffect(() => {
        const height = ref.current.scrollHeight
        ref?.current?.scrollTo(0, height)
    }, [payload?.message,messageList])

    const handleSend = () => {
        if (payload?.message?.trim().length < 1) {
            return false;
        }
        dispatch(addExecutiveMsg({
            user_id,
            ...payload
        }))
            .then((res) => {
                getMessageList()
                setPayload(initialState)
            })
            .catch((err) => {
                toastError(err?.data?.message)
            })
    }

    const getMessageList = () => {
        authService.getExecutiveMsg(user_id)
            .then(res => {
                setMessageList(res?.data?.response?.messages)
            })
            .catch(err => {
                console.log('Error in Get Client Messages', err)
                toastError(err?.data?.message)
            })
    }
    useEffect(() => {
        getMessageList();
    }, [])

    
    const handleTemplets = (id, code) => {
        const selected = templateList?.find((itm, ind) =>itm?.id===id) || null
        
        setPayload({
            ...payload,
            message:selected?.description
        })
    }

    const handleChange = (name,value) => {

        setPayload({
            ...payload,
            [name]: value
        })
    }


  
    return (<div className="chat-wrapper-div">
        <div className="chat-wrapper">
            <div ref={ref} className="chat-messages-list">
                {
                    messageList?.length === 0 ? <p className="chat-start-conv">Start a conversation</p> : null
                }
                {messageList?.map((msg,index) => {
                    if (msg?.user_type === "CLIENT") {
                        return <Reciever key={index}
                            msg={msg?.message}
                            time={msg?.added_on}
                        />
                    } else if (msg?.user_type === "EXECUTIVE") {
                        return <Sender key={index} {...msg}/>
                    }

                })}

            </div>
            <ChatInput
                name="message"
                value={payload?.message}
                hint="write message here"
                templates={{ list: templateList, title: 'title', id: 'id', code: 'code' }}
                handleChange={handleChange}
                handleSend={handleSend}
                handleTemplets={(id,code)=>handleTemplets(id, code)}
            />
        </div>
    </div>
    );
};

export const ChatInput = (props) => {
    const [toggle, setToggle] = useState(false)

    const handleToggle = () =>{
        setToggle((prev) => !prev)
    }
    
    const handleTemplets = (e, id, code) => {
        e.preventDefault()
        props?.handleTemplets(id, code)
        setToggle(false)
        console.log(toggle)
    }
    return (
        <div className="chat-compose">
            <div className="chat-compose-actions-left">
                <IconAdd size='30px' color="navy" onClick={handleToggle} />
            </div>
            <textarea
                placeholder="Type here..."
                className="chat-input-textarea"
                value={props?.value}
                rows={5}
                onChange={(e) => {props?.handleChange('message',e.target.value)}}
            ></textarea>
            <div className="chat-compose-actions-right">
                <p><input type="checkbox" onChange={(e)=>props?.handleChange('notify_client',e.target.checked)} /> <b>Notify Client ?</b></p>
                <IconSendMessage size='30px' color="navy" onClick={props?.handleSend} />
            </div>
            <div className="short-window" 
                style={{
                    display: toggle ? 'flex' : 'none',
                }}
            >
                <div className="">
                    {props?.templates?.list?.map((itm, index) => {return <div className="tamplets-div" ><a href='' onClick={(e)=>handleTemplets(e,itm[props?.templates?.id], itm[props?.templates?.code])} key={index}>{itm[props?.templates?.title]}</a> <hr/></div>})}
                </div>
            </div>
        </div>
    );
};


const Sender = (props) => {
    return <div className='sender-div-section'>
        <div className="sender-div">
            <p>{props?.message}</p>
        </div>
        <div className="chat-message-info">
            <p> {props?.notify_client===true && <IconMail size='12px'/>}</p>
            <p>{showDatetime(props?.added_on)}</p>
        </div>
    </div>
}

const Reciever = (props) => {

    return <div className='reciever-div-section'>
        <div className="reciever-div">
            <p>{props?.msg}</p>
        </div>
        <div className="chat-message-info">
            <p>{showDatetime(props?.time)}</p>
        </div>
    </div>
}